import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

const ALL_BEEE_SUBTOPICS = [
    { name: 'Delta-star and Star-delta', path: '/beee-m1-s1' },
    { name: 'Thevenin, Mesh and Nodal Analysis', path: '/beee-m1-s2' },
    { name: 'Super position and Maximum power transformation', path: '/beee-m1-s3' },
    { name: 'Single Phase RLC series circuit and Three Phase', path: '/beee-m2-s1' },
    { name: 'Magnetic Circuits', path: '/beee-m3-s1' },
    { name: 'Self and Mutual Inductance and Transformers', path: '/beee-m3-s2' },
    { name: 'Electrical Machines', path: '/beee-m4-s1' },
    { name: 'Digital Systems', path: '/beee-m5-s1' },
    { name: 'K-map, Boolean, Logic gates, Adder, Multiplexer, Demultiplexer', path: '/beee-m5-s2' },
    { name: 'Semiconductor Devices and Applications', path: '/beee-m6-s1' }
];

const BEEEModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_BEEE_SUBTOPICS, subjectPath = '/subject-BEEEModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_BEEE_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default BEEEModuleSubtopic;
